"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyArticleSourceTranslations = applyArticleSourceTranslations;
exports.applyCategorySourceTranslations = applyCategorySourceTranslations;
exports.applyProductSourceTranslations = applyProductSourceTranslations;
exports.buildArticleUpdatePayload = buildArticleUpdatePayload;
exports.buildProductUpdatePayload = buildProductUpdatePayload;
exports.buildSourceSnapshot = buildSourceSnapshot;
exports.getSourceTranslationValue = getSourceTranslationValue;
exports.hasSourceChanged = hasSourceChanged;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 多语言维护：源语言（如 zh-CN）走主表更新，不写入 i18n 表。
 * 供各业务模块的 saveSource 复用。
 */

function getSourceTranslationValue(translations, fieldKey, sourceLangCode) {
  var map = (translations || {})[fieldKey] || {};
  var val = map[sourceLangCode];
  return val === undefined || val === null ? '' : String(val);
}
function buildSourceSnapshot(translations, fieldItems, sourceLangCode) {
  var snapshot = {};
  (fieldItems || []).forEach(function (field) {
    snapshot[field.fieldKey] = getSourceTranslationValue(translations, field.fieldKey, sourceLangCode);
  });
  return snapshot;
}
function hasSourceChanged(originalSnapshot, translations, fieldItems, sourceLangCode) {
  var current = buildSourceSnapshot(translations, fieldItems, sourceLangCode);
  return (fieldItems || []).some(function (field) {
    var key = field.fieldKey;
    return (originalSnapshot[key] || '') !== (current[key] || '');
  });
}
function cloneData(data) {
  return JSON.parse(JSON.stringify(data));
}

/**
 * 将源语言字段写回商品详情对象（仅覆盖 i18n 维护范围内的字段）
 */
function applyProductSourceTranslations(productInfo, translations) {
  var sourceLangCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'zh-CN';
  var info = cloneData(productInfo || {});
  var pick = function pick(fieldKey, fallbackKey) {
    var val = getSourceTranslationValue(translations, fieldKey, sourceLangCode);
    if (val !== '') {
      info[fallbackKey] = val;
    }
  };
  pick('product.storeName', 'storeName');
  pick('product.keyword', 'keyword');
  pick('product.storeInfo', 'storeInfo');
  pick('product.unitName', 'unitName');
  pick('description.content', 'content');
  if (Array.isArray(info.attr)) {
    info.attr = info.attr.map(function (attr, index) {
      var attrId = attr && attr.id !== undefined && attr.id !== null ? attr.id : index;
      var fieldKey = "sku.attrName.".concat(attrId);
      var newName = getSourceTranslationValue(translations, fieldKey, sourceLangCode);
      if (newName !== '') {
        return _objectSpread(_objectSpread({}, attr), {}, {
          attrName: newName
        });
      }
      return attr;
    });
  }
  if (Array.isArray(info.attrValue)) {
    info.attrValue = info.attrValue.map(function (item) {
      var fieldKey = "sku.".concat(item.id, ".suk");
      var newSuk = getSourceTranslationValue(translations, fieldKey, sourceLangCode);
      if (newSuk !== '') {
        return _objectSpread(_objectSpread({}, item), {}, {
          suk: newSuk
        });
      }
      return item;
    });
  }
  return info;
}

/**
 * 将商品详情格式化为 productUpdateApi 所需结构（与编辑页 prepareSubmitData 对齐）
 */
function buildProductUpdatePayload(productInfo) {
  var bizType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var info = cloneData(productInfo || {});
  var formData = _objectSpread(_objectSpread({}, info), {}, {
    cateId: info.cateId || '',
    sliderImage: info.sliderImage || '[]',
    bizType: bizType
  });
  if (info.activityStr && !formData.activity) {
    formData.activity = String(info.activityStr).split(',').filter(Boolean);
  }
  if (info.specType) {
    formData.attr = (info.attr || []).map(function (item) {
      return {
        attrName: item.attrName || '',
        id: item.id,
        attrValues: item.attrValues != null ? item.attrValues : Array.isArray(item.attrValue) ? item.attrValue.join(',') : ''
      };
    });
    formData.attrValue = (info.attrValue || []).map(function (item) {
      var newItem = _objectSpread({}, item);
      newItem.attrValue = _typeof(item.attrValue) === 'object' ? JSON.stringify(item.attrValue) : item.attrValue || '{}';
      delete newItem.value0;
      return newItem;
    });
  } else {
    formData.attr = [{
      attrName: '规格',
      attrValues: '默认',
      id: info.id ? info.attr && info.attr[0] && info.attr[0].id : 0
    }];
    formData.attrValue = (info.attrValue || [{}]).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        attrValue: _typeof(item.attrValue) === 'object' ? JSON.stringify(item.attrValue) : item.attrValue || JSON.stringify({
          '规格': '默认'
        })
      });
    });
  }
  return formData;
}

/**
 * 分类：将源语言名称写回分类对象
 */
function applyCategorySourceTranslations(categoryInfo, translations) {
  var sourceLangCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'zh-CN';
  var info = cloneData(categoryInfo || {});
  var name = getSourceTranslationValue(translations, 'category.name', sourceLangCode);
  if (name !== '') {
    info.name = name;
  }
  return info;
}

/**
 * 文章：将源语言字段写回文章详情对象
 */
function applyArticleSourceTranslations(articleInfo, translations) {
  var sourceLangCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'zh-CN';
  var info = cloneData(articleInfo || {});
  var pick = function pick(fieldKey, fallbackKey) {
    var val = getSourceTranslationValue(translations, fieldKey, sourceLangCode);
    if (val !== '') {
      info[fallbackKey] = val;
    }
  };
  pick('article.title', 'title');
  pick('article.author', 'author');
  pick('article.synopsis', 'synopsis');
  pick('article.content', 'content');
  return info;
}

/**
 * 将文章详情格式化为 UpdateArticle 所需结构（与编辑页对齐）
 */
function buildArticleUpdatePayload(articleInfo) {
  var info = cloneData(articleInfo || {});
  return {
    id: info.id,
    author: info.author,
    cid: info.cid,
    content: info.content || '',
    imageInput: info.imageInput,
    isBanner: info.isBanner,
    isHot: info.isHot,
    shareSynopsis: info.synopsis,
    shareTitle: info.title,
    sort: info.sort != null ? info.sort : 0,
    synopsis: info.synopsis,
    title: info.title,
    url: info.url
  };
}